module.exports = __webpack_public_path__ + "img/dpr-logo.d1c828a7.svg";